import WINDOW from "../../../../utils/window";

/**
 *
 * @param {TriggerProps} trigger
 * @param {"start" | "end"} type
 * @param {"x" | "y"} axis
 * @returns
 */
const getCoordsStartEnd = (trigger, type, axis) => {
  const dimension = /** @type {Number} */ (
    axis === "x" ? WINDOW.get("width") : WINDOW.get("height")
  );

  const pAll = /** @type {TriggerParameterTypeProps} */ (
    trigger.get(`p_${type}`)
  );

  const pAxis = /** @type {TriggerParameterTypeProps} */ (
    trigger.get(`p_${type}_-_${axis}`)
  );

  const vAll = /** @type {Number} */ (pAll.get("value"));
  const vAxis = /** @type {Number} */ (pAxis.get("value"));

  if (vAll) {
    return pAll.get("unit") === "%" ? (vAll / 100) * dimension : vAll;
  }

  if (vAxis) {
    return pAxis.get("unit") === "%" ? (vAxis / 100) * dimension : vAxis;
  }

  return 0;
};

export default getCoordsStartEnd;
